import * as types from "../constants/ActionTypes";

//non mutating array rm/insert implementations
function rmAt(arr, index) {
    return arr
        .slice(0, index)
        .concat(arr.slice(index + 1));
}

function insertAt(arr, index, ...items) {
    return arr
        .slice(0, index)
        .concat(items, arr.slice(index));
}

const genId = (()=> {
    let seq = 0;
    return ()=> seq++;
})();

const handlers = {
    [types.ADD_CHART]: (charts, {args}) => {
        if (!args) {
            throw new Error("ADD_CHART requires 'args' argument");
        }

        let defaults = {type: "BarChart"};
        return charts.concat({...defaults, ...args, id: genId()});
    },

    [types.DELETE_CHART]: (charts, {index}) => {
        if (index === void 0) {
            throw new Error("DELETE_CHART requires 'index' argument.");
        }

        return rmAt(charts, index);
    },

    [types.EDIT_CHART]: (charts, {index, args}) => {
        if (index === void 0 || args === void 0) {
            throw new Error("EDIT_CHART requires 'index' and 'args' arguments.");
        }

        let old = charts[index];
        return insertAt(rmAt(charts, index), index, {...args, id: old.id});
    },

    [types.MOVE_CHART]: (charts, {index, dir}) => {
        if (index === void 0 || dir === void 0) {
            throw new Error("MOVE_CHART requires index and dir arguments.");
        }

        dir = Number(dir);

        if (dir === 0 || isNaN(dir)) {
            throw new Error("MOVE_CHART requires 'dir' to be a non zero integer.");
        }

        dir = Math.min(dir, charts.length - index);
        dir = Math.max(dir, -1 * index);

        if (dir === 0) {
            return charts;
        }

        let old = charts[index];
        return insertAt(rmAt(charts, index), index + dir, old);
    },

    [types.LOAD_STATE]: (charts, {args}) => {
        if (args.charts === void 0 ) {
            return charts;
        }

        return args.charts
            .map(args => ({args}))
            .reduce(handlers[types.ADD_CHART], []);
    }
};

export default function chartsReducer(charts = [], action = {}) {
    const {type, index} = action;

    if (typeof handlers[type] == "function") {
        if (index !== void 0 && !charts[index]) {
            throw Error(type + "No chart with index " + index);
        }

        return handlers[type](charts, action);
    } else {
        return charts;
    }
}



// WEBPACK FOOTER //
// ./src/kpi/store/reducers/charts.js